import { render, staticRenderFns } from "./item-sales.vue?vue&type=template&id=23f861c2"
import script from "./item-sales.vue?vue&type=script&lang=js"
export * from "./item-sales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports